<template>
  <div
    v-if="totalPages > 1"
    class="absolute bottom-2 left-1/2 transform -translate-x-1/2 z-[2]"
  >
    <div
      class="bg-surface/80 backdrop-blur-sm rounded-full px-3 py-1 flex items-center gap-2"
    >
      <button
        :disabled="currentPage <= 1"
        class="p-1 rounded-full hover:bg-surface-variant disabled:opacity-50 disabled:cursor-not-allowed"
        @click="$emit('previous-page')"
      >
        <Icon :icon="ChevronLeftIcon" class="w-4 h-4" />
      </button>
      <span class="text-sm font-medium px-2">
        {{ currentPage }} / {{ totalPages }}
      </span>
      <button
        :disabled="currentPage >= totalPages"
        class="p-1 rounded-full hover:bg-surface-variant disabled:opacity-50 disabled:cursor-not-allowed"
        @click="$emit('next-page')"
      >
        <Icon :icon="ChevronRightIcon" class="w-4 h-4" />
      </button>
    </div>
  </div>
</template>

<script setup lang="ts">
import { Icon } from '~/components/icon';
import ChevronLeftIcon from '@/assets/icons/chevron-left.svg?component';
import ChevronRightIcon from '@/assets/icons/chevron-right.svg?component';

defineProps<{
  currentPage: number;
  totalPages: number;
}>();

defineEmits<{
  (e: 'previous-page'): void;
  (e: 'next-page'): void;
}>();
</script>
